import Header from '../components/general/Header';
import Hero from '../components/home/Hero';
import MediaPlayer from '../components/home/MediaPlayer';
import Experience from '../components/home/Experience';
import Testimonials from '../components/home/Testimonials';
import FinalCta from '../components/home/FinalCta';
import site from '../data/master.json';
import Footer from '../components/general/Footer';
import RewardsToast from '../components/rewards/RewardsToast';

export default function Landing() {
  return (
    <div>
      <Header />
      <Hero data={site.hero} />
      <MediaPlayer data={site.discography} />
      <Experience data={site.experience} />
      <Testimonials data={site.testimonials} />
      <FinalCta data={site.finalCta} />
      <Footer data={site.footer} />
      <RewardsToast />
    </div>
  );
}